
export class featureGenerateColor {
  
  public static getColorBetween(color1: string, color2: string, ratio: number): string {
    if (ratio < 0 || ratio > 1) {
      throw new Error('Ratio must be between 0 and 1');
    }
    
    // Convert hex colors to RGB
    const rgb1 = this.hexToRgb(color1);
    const rgb2 = this.hexToRgb(color2);
    
    // Calculate the intermediate RGB values
    const r = Math.round((1 - ratio) * rgb1.r + ratio * rgb2.r);
    const g = Math.round((1 - ratio) * rgb1.g + ratio * rgb2.g);
    const b = Math.round((1 - ratio) * rgb1.b + ratio * rgb2.b);
    
    // Convert RGB values to hex color
    const hex = this.rgbToHex(r, g, b);
    
    return hex;
  }

  
  private static hexToRgb(hex: string) {
    const bigint = parseInt(hex.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return {r, g, b};
  }

// Helper function to convert RGB to hexadecimal color
  private static rgbToHex(r: number, g: number, b: number) {
    const componentToHex = (c: number) => {
      const hex = c.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };
    return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
  }
  
  
  // public static getNextColorInGradient(color1: string, color2: string, step: number): string {
  //   const rgb1 = this.hexToRgb(color1);
  //   const rgb2 = this.hexToRgb(color2);
  //
  //   const getNextValue = (val1: number, val2: number): number => {
  //     const diff = val2 - val1;
  //     return val1 + (diff * step);
  //   };
  //
  //   const r = getNextValue(rgb1.r, rgb2.r);
  //   const g = getNextValue(rgb1.g, rgb2.g);
  //   const b = getNextValue(rgb1.b, rgb2.b);
  //
  //   return this.rgbToHex(Math.round(r), Math.round(g), Math.round(b));
  // }
  
  public static predictNextColor(color1: string, color2: string): string {
    // Parse color strings to extract RGB values
    const rgb1 = this.hexToRgb(color1);
    const rgb2 = this.hexToRgb(color2);
    
    // Calculate the intermediate RGB values
    const r = Math.round((rgb1.r + rgb2.r) / 2);
    const g = Math.round((rgb1.g + rgb2.g) / 2);
    const b = Math.round((rgb1.b + rgb2.b) / 2);
    
    // Convert RGB values back to a hex color string
    const hex = this.rgbToHex(r, g, b);
    
    return hex;
  }
  
  public static makeColorStronger(color: string, strength: number): string {
    // Parse the color string to extract RGB values
    const rgb = this.hexToRgb(color);
    
    // Increase the intensity of each RGB component
    const strongerR = Math.min(Math.round(rgb.r * strength), 255);
    const strongerG = Math.min(Math.round(rgb.g * strength), 255);
    const strongerB = Math.min(Math.round(rgb.b * strength), 255);
    
    // Convert the stronger RGB values back to a hex color string
    const strongerHex = this.rgbToHex(strongerR, strongerG, strongerB);
    
    return strongerHex;
  }

}